// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
import { language, pageName } from '@sitecore-cloudsdk/core';
export class BaseEvent {
    /**
     * The base event class that has all the shared functions between Events
     * @param baseEventData - The event data to send
     * @param settings - The global settings
     * @param id - The browser id
     * @param infer - The source of methods to estimate language and page parameters
     */
    constructor(baseEventData, id) {
        this.baseEventData = baseEventData;
        this.browserId = id;
        this.language = this.baseEventData.language ?? language();
        this.page = this.baseEventData.page ?? pageName();
    }
    /**
     *  A function that returns the properties for sending events to Sitecore EP
     * @returns an object that is required
     */
    mapBaseEventPayload() {
        return {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            browser_id: this.browserId,
            channel: this.baseEventData.channel,
            /* eslint-disable @typescript-eslint/naming-convention */
            client_key: '',
            currency: this.baseEventData.currency,
            language: this.language,
            page: this.page,
            pos: '',
        };
    }
}
